import React, { useState, useEffect } from 'react';
import { Terminal as TerminalIcon } from 'lucide-react';

const Terminal = () => {
  const [text, setText] = useState('');
  const fullText = `
> whoami
robin@kali

> cat contact_info.txt
EMAIL: robiln1101@gmail.com
INSTAGRAM: @sunnynt0
DISCORD: user/958427812358918144

> ./contact_me.sh
Feel free to reach out! Always interested in new opportunities.
`;

  useEffect(() => {
    let index = 0;
    const timer = setInterval(() => {
      setText(fullText.slice(0, index));
      index++;
      if (index > fullText.length) clearInterval(timer);
    }, 50);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="max-w-2xl mx-auto">
      <div className="backdrop-blur-sm bg-black/30 rounded-lg overflow-hidden border border-white/10">
        {/* Terminal Header */}
        <div className="flex items-center justify-between px-4 py-2 bg-white/5">
          <div className="flex items-center space-x-2">
            <TerminalIcon size={16} className="text-gray-400" />
            <span className="text-sm text-gray-400">contact@robin</span>
          </div>
          <div className="flex space-x-2">
            <div className="w-3 h-3 rounded-full bg-red-500/50" />
            <div className="w-3 h-3 rounded-full bg-yellow-500/50" />
            <div className="w-3 h-3 rounded-full bg-green-500/50" />
          </div>
        </div>

        {/* Terminal Content */}
        <div className="p-4 font-mono text-sm">
          <pre className="text-gray-300 whitespace-pre-wrap">
            {text}
          </pre>
          <div className="flex items-center mt-2">
            <span className="text-gray-400">$</span>
            <span className="w-2 h-4 ml-2 bg-gray-400 animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terminal;